/** @jsxImportSource @emotion/react */
import React from 'react';
import { betaTileStyles } from './beta-tile.styles';
import icon from './icon.png';
import { useIntl } from 'react-intl';

const BetaTile = () => {
    const intl = useIntl();

    return (
        <div css={betaTileStyles.container}>
            <img src={icon} alt="icon" css={betaTileStyles.icon} />
            <span css={betaTileStyles.title}>{intl.formatMessage({ id: 'betaWarning' })}</span>
        </div>
    );
};

export default BetaTile;
